module.exports = __webpack_public_path__ + "static/MXC-269ebebaf3d920ef4d5e06ae5b8d5fd0.png";